import { render } from "./MultiselectLocations2.vue?vue&type=template&id=188411b8&scoped=true"
import script from "./MultiselectLocations2.vue?vue&type=script&lang=js"
export * from "./MultiselectLocations2.vue?vue&type=script&lang=js"

import "./MultiselectLocations2.vue?vue&type=style&index=0&id=188411b8&lang=css"
import "./MultiselectLocations2.vue?vue&type=style&index=1&id=188411b8&scoped=true&lang=css"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188411b8"]])

export default __exports__